import { useState, Fragment } from 'react';
import { Space, Button } from 'antd';
import notificationWithIcon from 'components/Notification/notificationWithIcon';
import ListTopics from '../ListTopics';
import data from './data';
import exercise from './exerciseSkills';

const changeColors = (index) => {
  const color = ['#FD9726', '#2ACFD3', '#F24422', '#7A57CE', '#8BC427', '#00A1DE'];
  let newIndex = index;
  while (newIndex > color.length - 1) newIndex -= color.length;
  return color[newIndex];
};

function ListUnits({ classFields, openListTopics, onClick }) {
  const [unit, setUnit] = useState(0);

  const handleLearn = (v) => {
    if (v.access) {
      setUnit(v.unit);
      if (typeof onClick === 'function') onClick(v.id);
    } else {
      notificationWithIcon('warning', 'Thông báo', 'Không có dữ liệu !');
    }
  };

  return (
    <div>
      {openListTopics ? (
        <ListTopics classFields={classFields} unit={unit} />
      ) : (
        <Space size={[1, 32]} wrap style={{ display: 'flex', justifyContent: 'space-between' }}>
          {data.map((item, index) => {
            return (
              <div key={item.id} className='bg-white d-flex flex-grow-1 flex-column' style={{ borderRadius: 5, height: '100%', border: `1px solid ${changeColors(index)}` }}>
                <div className='d-flex py-2 px-2 align-items-center'>
                  <div
                    className='d-flex align-items-center justify-content-center mr-2'
                    style={{ marginLeft: -12, fontSize: 18, fontWeight: 700, font: '700 "Trebuchet MS",sans-serif', background: `${changeColors(index)}`, color: 'white', width: 45, height: 40, borderRadius: '0px 30px 30px 0px' }}
                  >
                    {item.unit}
                  </div>
                  <div style={{ fontSize: 26, color: `${changeColors(index)}` }}>{`Unit ${item.unit}`}</div>
                </div>
                <div className='d-flex flex-grow-1 flex-column justify-content-center px-3 pt-1 pb-3'>
                  <div style={{ flex: 1 }}>
                    {exercise.skills.map((v, i) => {
                      const isLast = exercise.skills.length - 1 !== i;
                      return (
                        <Fragment key={v.id}>
                          <span>{v.visible && v.name}</span>
                          {v.visible && isLast && <span>, </span>}
                        </Fragment>
                      );
                    })}
                  </div>
                  <Button onClick={() => handleLearn(item)} className='py-2 my-2' style={{ background: `${changeColors(index)}`, color: 'white', height: 'fit-content', fontWeight: 600 }}>
                    Chọn đề luyện tập
                  </Button>
                </div>
              </div>
            );
          })}
        </Space>
      )}
    </div>
  );
}

export default ListUnits;
